import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { list } from "../features/notificationLog/notificationLogSlice";
import { Link } from "react-router-dom";

const NotificationLog = () => {
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 1000,
    key: "",
    status: "",
  });

  useEffect(() => {
    dispatch(list(pagination));
  }, [dispatch, pagination]);

  const { logs, total, isLoading } = useSelector(
    (state) => state.notificationLog
  );

  const handleTableChange = (pagination) => {
    dispatch(list(pagination));
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      total: total,
    }));
  }, [total]);

  const columns = [
    {
      title: "User",
      dataIndex: "user",
      render: (text, record) => (
        <Link to={`/admin/profile/${record.user?._id}`}>
          {record.user?.first_name} {record.user?.last_name}
        </Link>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Body",
      dataIndex: "body",
    },
    {
      title: "Data",
      dataIndex: "data",
    },
    {
      title: "Date",
      render: (record) => {
        const date = new Date(record.createdAt);
        const formattedDate = date.toLocaleDateString("en-US", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
        return `${formattedDate}, ${formattedTime}`;
      },
      key: "createdAt",
    },
  ];

  return (
    <div>
      <div className="row-space-between">
        <h3 className="mb-4 title">Notification Logs</h3>
        <div className="my-row">
          <div className="mr-5">
            {/* <IoSearchOutline className="fs-4" /> */}
            {/* <Input placeholder="Search users"
              value={searchQuery}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              prefix={<IoSearchOutline className="fs-4" />}
            /> */}
          </div>
        </div>
      </div>
      <p> {isLoading} </p>
      <div>
        <Table
          columns={columns}
          dataSource={logs}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={pagination}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default NotificationLog;
